module.exports = __webpack_public_path__ + "img/mr-mw.62a3727e.jpg";